import { render } from "./PhoneVerification.vue?vue&type=template&id=f75ba190&scoped=true"
import script from "./PhoneVerification.vue?vue&type=script&lang=js"
export * from "./PhoneVerification.vue?vue&type=script&lang=js"

import "./PhoneVerification.vue?vue&type=style&index=0&id=f75ba190&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f75ba190"]])

export default __exports__